
import { Entity } from '../base/entity';

export class Orn extends Entity {
    
    public static readonly TABLENAME = 'orn';
    
    public static readonly ID = "id";
    public static readonly CODE = "code";
    public static readonly DESCRIPTION = "description";
    
    id: number;
    code: string;
    description: string;
}